export const getDriverPosition = (
    driverLat?: number,
    driverLng?: number
) => {
    if (
        typeof driverLat !== "number" ||
        typeof driverLng !== "number" ||
        !Number.isFinite(driverLat) ||
        !Number.isFinite(driverLng)
    ) {
        return undefined;
    }

    return { lat: driverLat, lng: driverLng };
};

export const renderCenter = (useCustomMarker: boolean, lat: number, lng: number) => {
    return { lat: lat + (useCustomMarker ? 0.0020 : 0), lng };
};

export const fitMapToBounds = (
    map: google.maps.Map | null,
    customerLat: number,
    customerLng: number,
    driverLat: number,
    driverLng: number
) => {
    if (!map) return;

    const google = (window as any).google;
    if (!google) return;

    const bounds = new google.maps.LatLngBounds();

    bounds.extend({
        lat: customerLat,
        lng: customerLng,
    });

    bounds.extend({
        lat: driverLat,
        lng: driverLng,
    });

    map.fitBounds(bounds, {
        top: 100,
        bottom: 50,
        left: 85,
        right: 170,
    });
};

export const recenterMap = (
    map: google.maps.Map | null,
    lat: number,
    lng: number,
    useCustomMarker: boolean,
    driverLat?: number,
    driverLng?: number
) => {
    if (!map) return;

    const driverPosition = getDriverPosition(driverLat, driverLng);
    if (driverPosition) {
        fitMapToBounds(map, lat, lng, driverPosition.lat, driverPosition.lng);
    } else {
        map.panTo(renderCenter(useCustomMarker, lat, lng));
        map.setZoom(15);
    }
};

export const zoomInMap = (
    map: google.maps.Map | null,
    lat: number,
    lng: number,
    driverLat?: number,
    driverLng?: number
) => {
    if (!map) return;
    const currentZoom = map.getZoom()!;

    const driverPosition = getDriverPosition(driverLat, driverLng);
    if (driverPosition) {
        const centerLat = (lat + driverPosition.lat) / 2;
        const centerLng = (lng + driverPosition.lng) / 2;
        map.setOptions({ zoom: currentZoom + 1, center: { lat: centerLat, lng: centerLng } });
    } else {
        map.setOptions({ zoom: currentZoom + 1, center: { lat, lng } });
    }
};

export const zoomOutMap = (
    map: google.maps.Map | null,
    lat: number,
    lng: number,
    driverLat?: number,
    driverLng?: number
) => {
    if (!map) return;
    const currentZoom = map.getZoom()!;

    const driverPosition = getDriverPosition(driverLat, driverLng);
    if (driverPosition) {
        const centerLat = (lat + driverPosition.lat) / 2;
        const centerLng = (lng + driverPosition.lng) / 2;
        map.setOptions({ zoom: currentZoom - 1, center: { lat: centerLat, lng: centerLng } });
    } else {
        map.setOptions({ zoom: currentZoom - 1, center: { lat, lng } });
    }
};